import { isNull, omitBy } from 'lodash';
import { DateTime } from 'luxon';

export const createDDBItem = (data: any) => {
  return omitBy(
    {
      title: data.title,
      location: data.location,
      from: DateTime.fromISO(data.range.startDate).toSeconds(),
      to: DateTime.fromISO(data.range.endDate).toSeconds(),
      imageurl: data.imageurl,
      is_active: data.is_active,
    },
    isNull,
  );
};
